import { baseApi } from 'core/api';
import { cloneDeep } from 'lodash';
import { loggerVue } from 'services/logger';
import { useUserStore } from 'store/modules';

const state = () => ({
    _items: [],
    _isActiveTimer: false,
});

const getters = {};

const actions = {
    sendLogs(payload) {
        return baseApi.post('logger/v1/logs', { data: payload });
    },

    async sendLogsData() {
        try {
            const params = cloneDeep(this._items);

            this.resetLogsDataTimer();
            this.resetLogsData();
            await this.sendLogs(params);
        } catch (e) {
            loggerVue.error(e, '', 'sendLogsData');
        }
    },

    setLogItem({ logLevel, details, message }) {
        const userStore = useUserStore();
        const versionOfDesign = userStore.userSettings.find(
            (setting) => setting.key === 'salesmsg-design-v2'
        )?.settings['active']
            ? 'v2'
            : 'v1';
        const data = {
            timestamp: new Date().toISOString(),
            source: `${window.Config.env}-web-app-${versionOfDesign}`,
            message,
            logLevel,
            details,
        };

        if (this._isActiveTimer && this._items.length < 50) {
            this.updateLogsData(data);

            return;
        }

        if (!this._isActiveTimer && this._items.length < 50) {
            this.updateLogsData(data);
            this.setLogsDataTimer();

            setTimeout(() => {
                this.sendLogsData();
            }, 5000);

            return;
        }

        if (this._items.length === 50) {
            this.sendLogsData();
        }
    },

    updateLogsData(data) {
        this._items.push(data);
    },

    resetLogsData() {
        this._items = [];
    },

    resetLogsDataTimer() {
        this._isActiveTimer = false;
    },

    setLogsDataTimer() {
        this._isActiveTimer = true;
    },
};

export default {
    state,
    getters,
    actions,
};
